import { useState, useEffect } from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import { useFormik } from 'formik'
import { useHistory } from 'react-router-dom'
import { useAuth } from '../../../contexts/AuthProvider'
import Swal from 'sweetalert2'

const schema = Yup.object().shape({
  password: Yup.string()
    .min(6, 'Mínimo 6 caracteres')
    .max(50, 'Máximo 50 caracteres')
    .required('Nova senha é obrigatória'),
  confirmPassword: Yup.string()
    .required('Confirmação é obrigatória'),
})

export function DefinirSenha() {
  const [loading, setLoading] = useState(false)
  const { completePasswordChange, mustChangePassword } = useAuth()
  const history = useHistory()

  useEffect(() => {
    if (!mustChangePassword) {
      history.replace('/login')
    }
  }, [mustChangePassword, history])

  const formik = useFormik({
    initialValues: { password: '', confirmPassword: '' },
    validationSchema: schema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      if (values.password !== values.confirmPassword) {
        setStatus('As senhas não são iguais.')
        return
      }

      setLoading(true)
      try {
        await completePasswordChange(values.password)
        await Swal.fire({
          text: 'Senha definida com sucesso! Você já está logado.',
          icon: 'success',
          timer: 2000,
          showConfirmButton: false,
        })
      } catch (error: any) {
        setLoading(false)
        setSubmitting(false)
        const msg =
          error?.code === 'auth/weak-password'
            ? 'A senha deve ter pelo menos 6 caracteres.'
            : error?.code === 'auth/requires-recent-login'
            ? 'Sessão expirada. Faça login novamente.'
            : error?.message ?? 'Não foi possível definir a senha. Tente novamente.'
        setStatus(msg)
      }
    },
  })

  return (
    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_definir_senha_form'
    >
      <div className='mb-10 text-center'>
        <h1 className='text-dark mb-3'>Defina sua senha</h1>
        <p className='text-gray-400 fw-bold fs-6'>
          Este é seu primeiro acesso. Por segurança, escolha uma senha pessoal.
        </p>
      </div>

      {formik.status && (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      )}

      <div className='fv-row mb-5'>
        <label className='form-label fw-bolder text-dark fs-6 mb-0'>Nova senha</label>
        <input
          placeholder='Nova senha'
          type='password'
          autoComplete='new-password'
          {...formik.getFieldProps('password')}
          className={clsx('form-control form-control-lg form-control-solid', {
            'is-invalid': formik.touched.password && formik.errors.password,
            'is-valid': formik.touched.password && !formik.errors.password,
          })}
        />
        {formik.touched.password && formik.errors.password && (
          <div className='fv-plugins-message-container'>
            <span role='alert'>{formik.errors.password}</span>
          </div>
        )}
      </div>

      <div className='fv-row mb-5 mt-6'>
        <label className='form-label fw-bolder text-dark fs-6 mb-0'>Confirmar senha</label>
        <input
          placeholder='Confirmar senha'
          type='password'
          autoComplete='new-password'
          {...formik.getFieldProps('confirmPassword')}
          className={clsx('form-control form-control-lg form-control-solid', {
            'is-invalid': formik.touched.confirmPassword && formik.errors.confirmPassword,
            'is-valid': formik.touched.confirmPassword && !formik.errors.confirmPassword,
          })}
        />
        {formik.touched.confirmPassword && formik.errors.confirmPassword && (
          <div className='fv-plugins-message-container'>
            <span role='alert'>{formik.errors.confirmPassword}</span>
          </div>
        )}
      </div>

      <div className='text-center mt-8'>
        <button
          type='submit'
          className='btn btn-lg btn-primario w-100 mb-5'
          disabled={loading}
        >
          {!loading
            ? <span className='indicator-label'>DEFINIR SENHA E ENTRAR</span>
            : <span className='indicator-progress' style={{ display: 'block' }}>
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                Aguarde...
              </span>
          }
        </button>
      </div>
    </form>
  )
}
